import React from 'react';
import VintageHero from '../components/Hero/VintageHero';
import About from '../components/About/About';
import Timeline from '../components/Timeline/Timeline';
import Menu from '../components/Menu/Menu';
import TeamSection from '../components/Team/TeamSection';
import DidYouKnowSection from '../components/DidYouKnow/DidYouKnowSection';
import LocationSection from '../components/Location/LocationSection';
import ImageCarousel from '../components/ImageCarousel/ImageCarousel';

export default function Home() {
  return (
    <>
      <VintageHero />
      <About />
      <Timeline />
      <Menu />
      <TeamSection />
      <DidYouKnowSection />
      <LocationSection />
      <ImageCarousel />
    </>
  );
}